/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { deleteResource, getAllResource } from '@/model/dataLayer/api/storage/inventoryNewApi'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false
  },
  name: {
    displayName: 'resourceName'
  },
  // image: {},
  sku: {},
  maxLevelPrice: {
    displayName: 'MaximalUnitPrice',
    type: IKDataEntity.Types.Float,
    formConfig: {}
  },
  unitDisplay: {
    displayName: 'Stock',
    formConfig: {
      default: 0
    },
    form: false
  }
}

const config = {
  remove: async function (id) {
    return await deleteResource(id)
  },
  load: async function () {
    const arr = await getAllResource()
    return arr.map(it => {
      it.maxLevelPrice = it.maxLevelFactor * it.unitPrice
      if (it.currentCount === 0) {
        it.unitDisplay = '0'
      } else if (it.currentCount < 0) {
        it.unitDisplay = '-' + it.unitDisplay
      }
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
